import DrawerTypes from './DrawerTypes';
var FULL_HEIGHT = DrawerTypes.FULL_HEIGHT,
  CLIPPED = DrawerTypes.CLIPPED,
  FLOATING = DrawerTypes.FLOATING,
  PERSISTENT = DrawerTypes.PERSISTENT,
  PERSISTENT_MINI = DrawerTypes.PERSISTENT_MINI,
  TEMPORARY = DrawerTypes.TEMPORARY,
  TEMPORARY_MINI = DrawerTypes.TEMPORARY_MINI;
export function isTemporary(type) {
  return [TEMPORARY, TEMPORARY_MINI].indexOf(type) !== -1;
}
export function isPersistent(type) {
  return [PERSISTENT, PERSISTENT_MINI].indexOf(type) !== -1;
}
export function isPermanent(type) {
  return [FULL_HEIGHT, CLIPPED, FLOATING].indexOf(type) !== -1;
}
export function isMini(type) {
  return [PERSISTENT_MINI, TEMPORARY_MINI].indexOf(type) !== -1;
}